import "../../index19.css";
import { jsxs as a, jsx as o, Fragment as te } from "react/jsx-runtime";
import { a as n, i as ie } from "../../core-DVmjA3_O.js";
import { _ as b } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import oe from "../BlockView/index.js";
import ne from "../DefaultMessage/index.js";
import re from "../Description/index.js";
import ae from "../Heading/index.js";
import x from "../InlineView/index.js";
import s from "../ListView/index.js";
import se from "../../hooks/useSpacingToken.js";
import { getSpacingValue as le, paddingSpacings as ce } from "../../utils/style.js";
const de = "_container_m8lpi_1", he = "_with-fixed-height_m8lpi_2", we = "_with-shadow_m8lpi_7", pe = "_with-background_m8lpi_11", fe = "_with-dark-background_m8lpi_16", ge = "_content_m8lpi_21", me = "_pending-overlaid_m8lpi_26", _e = "_message_m8lpi_31", ue = "_with-overflow_m8lpi_36", Ce = "_with-padding-overflow_m8lpi_37", ve = "_overflow-container_m8lpi_44", ke = "_filters_m8lpi_51", Oe = "_with-content-well_m8lpi_56", e = {
  container: de,
  withFixedHeight: he,
  withShadow: we,
  withBackground: pe,
  withDarkBackground: fe,
  content: ge,
  pendingOverlaid: me,
  message: _e,
  withOverflow: ue,
  withPaddingOverflow: Ce,
  overflowContainer: ve,
  filters: ke,
  withContentWell: Oe
};
function Ve(N) {
  const {
    className: F,
    elementRef: M,
    heading: u,
    withEllipsizedHeading: P,
    headingLevel: I,
    headerIcons: C,
    headerActions: l,
    headerDescription: c,
    withHeaderBorder: W,
    withCenteredHeading: V,
    withCenteredHeaderDescription: A,
    withoutWrapInHeader: j,
    filters: d,
    footerIcons: v,
    footer: k,
    footerActions: O,
    withFooterBorder: z,
    children: h,
    withContentOverflow: w,
    withContentWell: S,
    empty: p = !1,
    filtered: H = !1,
    pending: f = !1,
    overlayPending: g,
    errored: m = !1,
    emptyMessage: E,
    filteredEmptyMessage: L,
    pendingMessage: R,
    errorMessage: $,
    withoutMessageIcon: G,
    withCompactMessage: T,
    withBackground: q,
    withDarkBackground: J,
    withShadow: K,
    withPadding: _,
    withFixedHeight: Q,
    spacing: t,
    spacingOffset: i = 0,
    withoutSpacingOpticalCorrection: r,
    ...U
  } = N, B = n(u) || n(C) || n(l), X = B || n(c), Y = n(k) || n(v) || n(O), Z = se({
    spacing: t,
    offset: i,
    modes: ce,
    withoutOpticalCorrection: r
  }), D = le(t, i), ee = w && _ ? /* @__PURE__ */ o(
    "div",
    {
      className: e.overflowContainer,
      style: {
        padding: `0 ${D}`,
        margin: `0 calc(-1 * ${D})`
      },
      children: h
    }
  ) : h, y = (h || p || f || m || H) && /* @__PURE__ */ a(te, { children: [
    /* @__PURE__ */ o(
      ne,
      {
        className: e.message,
        pending: f,
        filtered: H,
        errored: m,
        empty: p,
        overlayPending: g,
        emptyMessage: E,
        filteredEmptyMessage: L,
        pendingMessage: R,
        errorMessage: $,
        withoutIcon: G,
        compact: T
      }
    ),
    !p && !m && (!f || g) && ee
  ] });
  return /* @__PURE__ */ a(
    oe,
    {
      ...U,
      elementRef: M,
      className: b(
        e.container,
        q && e.withBackground,
        J && e.withDarkBackground,
        K && e.withShadow,
        S && e.withContentWell,
        Q && e.withFixedHeight,
        F
      ),
      spacing: t,
      spacingOffset: i,
      withoutSpacingOpticalCorrection: r,
      withPadding: _,
      before: X && /* @__PURE__ */ a(
        s,
        {
          spacing: t,
          spacingOffset: i,
          layout: "block",
          withSpacingOpticalCorrection: !0,
          children: [
            B && /* @__PURE__ */ o(
              x,
              {
                spacing: t,
                spacingOffset: i - 1,
                withoutSpacingOpticalCorrection: r,
                withoutWrap: j,
                before: C,
                after: l && /* @__PURE__ */ o(
                  s,
                  {
                    spacing: t,
                    spacingOffset: i - 1,
                    withSpacingOpticalCorrection: !r,
                    children: l
                  }
                ),
                children: /* @__PURE__ */ o(
                  ae,
                  {
                    level: I,
                    ellipsize: P,
                    centerAligned: V,
                    children: u
                  }
                )
              }
            ),
            c && /* @__PURE__ */ o(re, { withCenteredContent: A, children: c })
          ]
        }
      ),
      after: Y && /* @__PURE__ */ o(
        x,
        {
          spacing: t,
          spacingOffset: i,
          withoutSpacingOpticalCorrection: r,
          before: v,
          after: O,
          children: k
        }
      ),
      withbeforeSeparator: W,
      withafterSeparator: z,
      childrenContainerClassName: b(
        e.content,
        g && e.pendingOverlaid,
        w && e.withOverflow,
        _ && w && e.withPaddingOverflow,
        S && Z
      ),
      children: [
        n(d) && /* @__PURE__ */ a(
          s,
          {
            layout: "block",
            spacing: t,
            spacingOffset: i,
            children: [
              /* @__PURE__ */ o(
                s,
                {
                  gridContentClassName: e.filters,
                  layout: "grid",
                  numPreferredGridColumns: 6,
                  spacing: t,
                  spacingOffset: i - 1,
                  children: d
                }
              ),
              y
            ]
          }
        ),
        ie(d) && y
      ]
    }
  );
}
export {
  Ve as default
};
